import React from 'react'
import TeachersApp from '../../features/teachers/Teachers'
export default function Teachers() {
  return (<TeachersApp/>  )
}
